import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["menuItems", "triggerElement", "rowInfo", "triggerOn"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import _result from 'lodash/result';
import _castArray from 'lodash/castArray';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { Menu as AntMenu, Dropdown } from 'antd';
import styles from './kebabMenu.module.scss';
var MenuItem = AntMenu.Item;
var SubMenuItem = AntMenu.SubMenu;
var renderOverlayMenu = function renderOverlayMenu(onClickAction, rowInfo) {
  return function (_ref) {
    var key = _ref.key,
      Component = _ref.renderer,
      label = _ref.label,
      disabled = _ref.disabled;
    return (
      /*#__PURE__*/
      // eslint-disable-line
      React.createElement(MenuItem, {
        key: key,
        id: key,
        onClick: function onClick(e) {
          _result(e, 'domEvent.stopPropagation');
          onClickAction(key, rowInfo, label);
        },
        disabled: disabled
      }, Component ? /*#__PURE__*/React.createElement(Component, {
        rowInfo: rowInfo,
        onClick: onClickAction
      }) : label)
    );
  };
};
var onSubMenuTitleClick = function onSubMenuTitleClick() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
    domEvent = _ref2.domEvent;
  return domEvent === null || domEvent === void 0 ? void 0 : domEvent.stopPropagation();
};
var renderOverlaySubMenu = function renderOverlaySubMenu(onClickAction, rowInfo) {
  return function (_ref3) {
    var key = _ref3.key,
      label = _ref3.label,
      subMenuOptions = _ref3.subMenuOptions;
    return /*#__PURE__*/React.createElement(SubMenuItem, {
      key: key,
      title: label,
      onTitleClick: onSubMenuTitleClick
    }, _map(subMenuOptions, renderOverlayMenu(onClickAction, rowInfo)));
  };
};
var renderOverlay = function renderOverlay(items, onClickAction, rowInfo) {
  return /*#__PURE__*/React.createElement(AntMenu, null, _map(items, function (option) {
    if (!_isEmpty(option === null || option === void 0 ? void 0 : option.subMenuOptions)) return renderOverlaySubMenu(onClickAction, rowInfo)(option);
    return renderOverlayMenu(onClickAction, rowInfo)(option);
  }));
};
var KebabMenu = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(KebabMenu, _React$PureComponent);
  var _super = _createSuper(KebabMenu);
  function KebabMenu() {
    var _this;
    _classCallCheck(this, KebabMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onClickAction", function (key, rowInfo, label) {
      var onClickAction = _this.props.onClickAction;
      onClickAction(key, rowInfo, label);
    });
    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      e.stopPropagation();
    });
    return _this;
  }
  _createClass(KebabMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        menuItems = _this$props.menuItems,
        triggerElement = _this$props.triggerElement,
        rowInfo = _this$props.rowInfo,
        triggerOn = _this$props.triggerOn,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Dropdown, _extends({
        overlay: renderOverlay(menuItems, this.onClickAction, rowInfo),
        trigger: _castArray(triggerOn),
        onClick: this.handleOnClick
      }, restProps), triggerElement);
    }
  }]);
  return KebabMenu;
}(React.PureComponent);
export { KebabMenu as default };
KebabMenu.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    renderer: PropTypes.func,
    onClick: PropTypes.func,
    key: PropTypes.string,
    subMenuOptions: PropTypes.array
  })).isRequired,
  triggerElement: PropTypes.object,
  onClickAction: PropTypes.func.isRequired,
  rowInfo: PropTypes.object.isRequired,
  triggerOn: PropTypes.string
};
KebabMenu.defaultProps = {
  triggerElement: /*#__PURE__*/React.createElement("span", {
    className: "icon-overflow ".concat(styles.kebabMenu)
  }),
  triggerOn: 'click'
};